import React, { useState } from 'react';
import styled from 'styled-components';
import "@fontsource/ibm-plex-mono";

const InputWrapper = styled.div`
  margin-bottom: 10px;
  width: 100%;
`;

const Label = styled.label`
  font-size: 12px;
  font-family: 'IBM Plex Mono';
  display: block;
  margin-bottom: 3px;
  padding-left: 15px;
  padding-right: 15px;
  `;

const Input = styled.input`
  width: 100%;
  height: 42px;
  border-radius: 20px;
  border: 2px solid #3B6255;
  background-color: #cde2d8;
  font-size: 14px;
  font-family: 'IBM Plex Mono';
  padding-left: 13px;
`;

const EyeIcon = styled.img`
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  width: 22px;
  height: 14x;
`;

const InputWithIcon = styled.div`
  position: relative;
`;

type Props = {
  label: string;
  type?: string;
  value: string;
  onChange: (val: string) => void;
  isPassword?: boolean;
};

const InputField: React.FC<Props> = ({ label, type = 'text', value, onChange, isPassword }) => {
  const [show, setShow] = useState(false);

  return (
    <InputWrapper>
      <Label>{label}</Label>
      <InputWithIcon>
        <Input
          type={isPassword && !show ? 'password' : 'text'}
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />
        {isPassword && (
          <EyeIcon onClick={() => setShow(!show)} src={`${process.env.PUBLIC_URL}/media/Eye_icon.svg`} alt="Eye"/>
        )}
      </InputWithIcon>
    </InputWrapper>
  );
};

export default InputField;
